// app/components/CookieInitializer.tsx
'use client'

import {useEffect} from 'react'
import {
    APP_COOKIE_APP_ORIGIN,
    APP_COOKIE_PROJECT_ID,
    APP_COOKIE_REFERRER_USER_ID,
    APP_SEARCH_PARAM_APP_ORIGIN,
    APP_SEARCH_PARAM_PROJECT_ID,
    APP_SEARCH_PARAM_REFERRER_USER_ID
} from "@/lib/constants";

export default function AppParamInitializer() {
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const params = new URLSearchParams(window.location.search);
        const referrerUserId = params.get(APP_SEARCH_PARAM_REFERRER_USER_ID);
        const projectId = params.get(APP_SEARCH_PARAM_PROJECT_ID);
        const appOrigin = params.get(APP_SEARCH_PARAM_APP_ORIGIN);

        console.info(`referrerUserId=${referrerUserId} projectId=${projectId} appOrigin=${appOrigin}`);

        if (!referrerUserId && !projectId && !appOrigin) return;

        // set 30-day cookies
        if (referrerUserId) {
            document.cookie = `${APP_COOKIE_REFERRER_USER_ID}=${referrerUserId}; path=/; max-age=${30 * 24 * 60 * 60}`;
        }
        if (projectId) {
            document.cookie = `${APP_COOKIE_PROJECT_ID}=${projectId}; path=/; max-age=${30 * 24 * 60 * 60}`;
        }
        if (appOrigin) {
            document.cookie = `${APP_COOKIE_APP_ORIGIN}=${appOrigin}; path=/; max-age=${30 * 24 * 60 * 60}`;
        }

        // remove params from URL
        window.history.replaceState({}, '', window.location.pathname);
    }, []);

    return null;
}